//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@/shared/form/form-schema';
import { CityModel } from '@/modules/city/city-model';
import { i18n } from '@/vueI18n';
import lodash from 'lodash';

const { fields } = CityModel;
const formSchema = new FormSchema([
  fields.id,
  fields.name,
  fields.country_id,
  fields.city_ascii,
  fields.center,
  fields.country,
]);

export default {
  name: 'app-city-form-page',
  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
    };
  },
  computed: {
    ...mapGetters({
      record: 'city/form/record',
      findLoading: 'city/form/findLoading',
      saveLoading: 'city/form/saveLoading',
      autocompleteList: 'country/list/autocompleteList',
      autocompleteLoading: 'country/list/autocompleteLoading',

      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
    }),
    isEditing() {
      return !!this.id;
    },
    fields() {
      return fields;
    },
    lodash() {
      return lodash
    },
    countryOptions() {
      if (this.isEditing && !this.autocompleteList.length && !this.autocompleteLoading) {
        return this.record && this.record['country']
          ? [{ id: this.record.country_id, label: this.record.country.name[this.currentLanguageCode] }] 
          : []
      }
      return this.autocompleteList
    },
  },
  
  async created() {
    if (this.isEditing) {
      await this.doFind(this.id);
    } else {
      await this.doNew();
    }
    this.model = formSchema.initialValues(this.record);

    if (!this.isEditing) {
      this.model.name = {
        en: undefined,
        ar: undefined,
      }
      this.model.center = {
        latitude: undefined,
        longitude: undefined,
      }
    }
  },
  methods: {
    ...mapActions({
      doFind: 'city/form/doFind',
      doNew: 'city/form/doNew',
      doUpdate: 'city/form/doUpdate',
      doCreate: 'city/form/doCreate',
      doFetchCountryAutocomplete: 'country/list/doFetchCountryAutocomplete',
    }),
    i18n(code) {
      return i18n(code);
    },
    doReset() {
      this.model = formSchema.initialValues(this.record);
    },
    getCountryAutoComplete(query) {
      this.doFetchCountryAutocomplete({
        search: query, 
        // limit: 10
      })
    },
    async doSubmit() {
      delete this.model.country
      const { id, ...values } = formSchema.cast(this.model);
      if (this.isEditing) {
        return await this.doUpdate({
          id,
          values,
        });
      } else {
        let record = await this.doCreate(values);
        return record;
      }
    },
  },
  watch:{
    'model.name.en'(newval) {
      this.model.city_ascii = newval
    }
  },
};
